import React from 'react';
import { Button, Icon, Modal, Select, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { APP_ROOT_EL_ID } from '@src/constant';
import TouchScroll from '@src/components/TouchDevice/TouchScroll';
import eula from '@src/assets/eula.js';

/**
 * reference: https://gist.github.com/stevenkaspar/be4f8121b670f9701f5de5286ab5ac7c
 */
class CustomIframe extends React.Component {
  constructor(props) {
    super(props);

    this.iframeRef = null;
    this.writeHTML = this.writeHTML.bind(this);
  }

  writeHTML(frame) {
    if (!frame) {
      return;
    }

    this.iframeRef = frame;

    let doc = frame.contentDocument;

    doc.open();
    doc.write(this.props.children);
    doc.close();

    frame.style.width = '100%';
    frame.style.height = '100%';

    let color = getComputedStyle(document.getElementById(APP_ROOT_EL_ID)).getPropertyValue(
      '--color-symbol-category-menu-item'
    );

    let body = frame.contentWindow.document.body;
    body.style.marginTop = 0;
    body.style.marginBottom = 0;
    body.style.color = color;
  }

  render() {
    const { children, ...otherProps } = this.props;
    return <iframe src="about:blank" {...otherProps} ref={this.writeHTML}></iframe>;
  }
}

function SettingDialog({ onCancel }) {
  const { t, i18n } = useTranslation();

  return (
    // TODO: create modal hoc to give consistent style
    <Modal
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', width: 'calc(100% - 16px)' }}>
          <span>{t('menu.settingModal.title')}</span>
          <span>{process.env.REACT_APP_VERSION}</span>
        </div>
      }
      visible={true}
      width={500}
      bodyStyle={{ padding: '12px 24px 24px' }}
      footer={
        <Button type="primary" onClick={onCancel}>
          {t('menu.settingModal.okButtonText')}
        </Button>
      }
      onCancel={onCancel}
      maskClosable={false}
      destroyOnClose={true}
    >
      <div className="lncd-setting-body">
        <Tabs type="card">
          <Tabs.TabPane tab={t('menu.settingModal.settingTabText')} key="setting">
            <div className="lncd-setting-item">
              {/* FIXME: why using this class?! */}
              <label className="custom-night-mode-text">{t('menu.settingModal.languageLabel')}:</label>
              <Select
                className="language-select"
                value={i18n.language}
                onChange={value => {
                  // FIXME: could we improve this?
                  i18n.changeLanguage(value);
                }}
                suffixIcon={<Icon type="caret-down" className="custom-night-mode-text lncd-select-suffix" />}
              >
                {Object.keys(i18n.store.data).map(language => (
                  // HACK: use 'name' namespace value of resource bundle as label
                  <Select.Option key={language}>{i18n.store.data[language].name}</Select.Option>
                ))}
              </Select>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('menu.settingModal.aboutTabText')} key="about">
            <div className="lncd-setting-item">
              <section>
                <b>About LexisNexis® Coplogic™ Solutions Inc.</b>
                <p>
                  LexisNexis® Coplogic Solutions Inc. helps law enforcement agencies address the challenge of protecting
                  their communities with fewer resources through a powerful suite of law enforcement solutions. By
                  combining native mobile field-based reporting with high-caliber analytics,{' '}
                  <b>LexisNexis Coplogic Solutions</b> provides law enforcement with a dynamic, unique suite of web and
                  cloud-based tools that can help agencies streamline operations and realize significant time and cost
                  savings, while also empowering them to expand services to the community and improve officer and public
                  safety. To learn more please visit{' '}
                  <a
                    href="https://risk.lexisnexis.com/law-enforcement-and-public-safety/automated-crash-and-incident-reporting"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    LexisNexisRisk.com/Coplogic
                  </a>{' '}
                  or contact us at 877.719.8806.
                </p>
              </section>
              <section>
                <b>LexisNexis® Crash Designer uses the following:</b>
                <p>Bing Maps © Microsoft.</p>
                <p>
                  Electron © GitHub licensed under MIT License{' '}
                  <a
                    href="https://github.com/electron/electron/blob/master/LICENSE"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://github.com/electron/electron/blob/master/LICENSE
                  </a>
                </p>
              </section>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('menu.settingModal.eulaTabText')} key="eula">
            <TouchScroll className="lncd-setting-item">
              <CustomIframe className="eula-container" width="100%" height="100%" name="eula" noresize="noresize">
                {eula}
              </CustomIframe>
            </TouchScroll>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Modal>
  );
}

export default SettingDialog;
